export enum UkMigrationElasticEvents {
    ForceBrandPostLoginAction = 'uk-migration-force-brand-post-login-action',
    OpenControlCenterPostLoginAction = 'uk-migration-open-control-center-post-login-action',
    UpdateUcCookie = 'uk-migration-update-uc-cookie',
    RemovePropertyFromUcCookie = 'uk-migration-remove-property-from-uc-cookie',
    OpenControlCenterFull = 'uk-migration-open-control-center-full',
}
